import { Container, Text } from '@pixi/react'
import { appScreen, Image, preciseMultiply, t } from '@slot-nx/core'

import { useBetDetailStore } from '../../domain/betDetail/store/betDetailStore'
import { Assets, TextStyle } from 'pixi.js'

import bg_payoutBox1 from '../../../asset/images/betDetail/image_bgPayout1.png'
import bg_payoutBox2 from '../../../asset/images/betDetail/image_bgPayout2.png'
import { formatNumberWithComma } from '../util/formatNumberUtil'

interface PayoutDetailBoxProps {
  y: number
}

Assets.addBundle('PayoutDetailBoxImage', [
  { alias: 'bg_payoutBox1', src: bg_payoutBox1, loadParser: 'loadTextures' },
  { alias: 'bg_payoutBox2', src: bg_payoutBox2, loadParser: 'loadTextures' },
])

export const PayoutDetailBox = (props: PayoutDetailBoxProps) => {
  const getCurrentTableSnapshot = useBetDetailStore(x => x.getCurrentTableSnapshot())
  const winningTotalPayout = getCurrentTableSnapshot.winningReels.reduce((acc, cur) => {
    return acc + cur.payout
  }, 0)
  const multiplier = getCurrentTableSnapshot.finalMultiplier
  const totalPayout = preciseMultiply(winningTotalPayout, multiplier)

  return (
    <Container
      key="WinLineBackground"
      name="WinLineBackground"
      x={37}
      y={props.y}
      width={appScreen.width - 110}
      height={371}
    >
      <Image
        image="bg_payoutBox1"
        x={0}
        y={0}
      />
      <WinLineContent x={40} y={20} multiplier={getCurrentTableSnapshot.finalMultiplier} payout={winningTotalPayout} />
      <Text
        x={95}
        y={328}
        name="Total"
        text={t('betDetail_winLine_total')}
        anchor={[0.5, 0.5]}
        style={
          new TextStyle({
            fontSize: 42,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#F7F7F7',
          })
        }
      />
      <Text
        x={appScreen.width - 140}
        y={328}
        anchor={[1, 0.5]}
        name="payout"
        text={`${formatNumberWithComma(totalPayout)}`}
        style={
          new TextStyle({
            fontSize: 45,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#F8E684',
            align: 'left',
            letterSpacing: 1.25,
          })
        }
      />
    </Container>
  )
}

interface WinLineContentProps {
  x: number
  y: number
  multiplier: number
  payout: number
}

export const WinLineContent = (props: WinLineContentProps) => {
  return (
    <Container>
      <Text
        x={45}
        y={70}
        name="Total"
        text={t('betDetail_winMultiplier')}
        anchor={[0, 0.5]}
        style={
          new TextStyle({
            fontSize: 42,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#F7F7F7',
          })
        }
      />
      <Text
        x={appScreen.width - 307}
        y={70}
        anchor={[1, 0.5]}
        name="payout"
        text={`x${props.multiplier}`}
        style={
          new TextStyle({
            fontSize: 42,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#fff',
            align: 'left',
            letterSpacing: 1.25,
          })
        }
      />
      <Text
        x={appScreen.width - 140}
        y={70}
        anchor={[1, 0.5]}
        name="payout"
        text={t('betDetail_applied')}
        style={
          new TextStyle({
            fontSize: 42,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#58667a',
            align: 'left',
          })
        }
      />

      <Text
        x={45}
        y={188}
        name="Total"
        text={t('betList_payout')}
        anchor={[0, 0.5]}
        style={
          new TextStyle({
            fontSize: 42,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#F7F7F7',
          })
        }
      />
      <Text
        x={appScreen.width - 140}
        y={188}
        anchor={[1, 0.5]}
        name="payout"
        text={`${formatNumberWithComma(props.payout)} x ${props.multiplier}`}
        style={
          new TextStyle({
            fontSize: 42,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            fill: '#76fff6',
            align: 'left',
            letterSpacing: 1.25,
          })
        }
      />

    </Container>
  )
}
